<template>
  <div class="list-box">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="办公费用"
    >
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[{ Text: '全部' }, ...$base.Office_Expense_Apply_Status]"
        :empty-values="[null, undefined, 0]"
        class="c-segmented"
        @change="onLoad"
      />
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        ref="tableDom"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="状态" label2="审批人" />
          </template>
           <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <text v-if="row.status == 0">
                  {{ row.flowApproveStep?.step_name }}
                </text>
                <c_status
                  v-else
                  arrName="Office_Expense_Apply_Status"
                  :value="row.status"
                />
              </template>
              <template #bottom>
                <ul class="flex gap-x-2">
                  <text class="text-gray-600">
                    {{ row?.flowApproveStep?.approve_admin_name }}
                  </text>
                  <text>{{
                    row?.flowApproveStep?.approve_department_name
                  }}</text>
                </ul>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :width="300">
          <template #header>
            <div
              class="c-table-col-header"
              label1="费用名称"
              label2="申请单/申请人"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value2="row.meeting?.start_date + ' ~ ' + row.meeting?.end_date"
            >
              <template #top>
                <div
                  class="flex items-center text-green-700 cursor-pointer hover:underline"
                >
                  <strong>{{ row.name }}</strong>
                  <text class="text-xs">
                    {{ "[" + row.number + "]" }}
                  </text>
                </div>
              </template>
              <template #bottom>
                <div
                  class="flex items-center text-gray-400 text-xs gap-x-2 mt-2"
                >
                  <text class="text-sm text-gray-600">
                    {{ row?.add_admin_name }}
                  </text>
                  <text>{{ row?.add_department_name }}</text>
                  <text class="ml-1">{{ row?.create_time }} 创建</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="type_name">
          <template #default="{ row }">
            <text>{{
              row.d_office_expense_type_pname + " - " + row.d_office_expense_type_name
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          label="合计金额"
          prop="amount"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column label="支付渠道" prop="type_name">
          <template #default="{ row }">
            <c_status
              arrName="Office_Expense_Apply_Payment_Method"
              :value="row.payment_method"
              :key="row.payment_method"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="intro"
          label="申请说明"
          :formatter="$tab_TextFormat"
          :min-width="160"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="success"
              :icon="Search"
              link
              @click.stop="
                state.selectId = row.id;
                state.showDetail = true;
              "
              >查看
            </el-button>
            <el-button
              v-if="row.status == 0"
              :icon="Close"
              link
              @click.stop="onCancel(row)"
            >
              取消
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click.stop="onDelete(row)"
              v-if="row.status == 4"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}办公费用`"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    :lock-scroll="false"
  >
    <c_info
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showDetail"
    title="办公费用详情"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 70%"
  >
    <c_detail :id="state.selectId" @close="state.showDetail = false" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  officeExpenseApply_page,
  officeExpenseApply_cancel,
  officeExpenseApply_delete,
} from "@/http/bangongfeiyong";
import { onDeleteConfirm, post_response } from "@/utils/funcs";
import { ElMessageBox, ElMessage } from "element-plus";

import c_info from "./Info.vue";
import c_detail from "./Detail.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: { c_info, c_detail },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      officeExpenseApply_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onCancel = (row) => {
      ElMessageBox.prompt(
        `您确定<strong>取消</strong>当前费用申请单吗？`,
        "提示",
        {
          confirmButtonText: "确定取消",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "el-button--danger",
          cancelButtonClass: "is-plain",
          inputPattern: /\S/,
          inputType: "textarea",
          inputPlaceholder: "请输入取消说明",
          inputErrorMessage: "请输入取消说明",
        },
      ).then(({ value }) => {
        officeExpenseApply_cancel({
          id: row.id,
          cancel_msg: value,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoad();
            }, 500);
          });
        });
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(officeExpenseApply_delete, row.id, onLoad, {
        filed: "费用申请单",
        name: row.name,
      });
    };

    return {
      state,
      props,
      tableDom,
      onLoad,
      onCancel,
      onDelete,
    };
  },
};
</script>

<style lang="scss" scoped></style>
